exports.HEADER_HEIGHT = 56;
exports.DEFAULT_DEBOUNCE_TIMEOUT = 800;
exports.GRAPH_CAMERA_PAN_DURATION = 700;

exports.defaultScrollY = (isMobile, windowInnerHeight) => {
  return windowInnerHeight / (isMobile ? 3 : 4);
};
